
<div class="overlay" *ngIf="showSpinner">
  <div class="spinner-wrapper">
    <app-spinner><span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span></app-spinner>
  </div>
</div>

<p-table #batchlist [columns]="cols" [value]="batches" [lazy]="true" (onLazyLoad)="loadBatchesLazy($event)" [paginator]="true"
         [rows]="20" [totalRecords]="totalRecords" [loading]="loading">
  <ng-template pTemplate="caption" [style]="{'height':'30px !important'}">
    <div style="height: 30px; width: 100%">
      <span class="float-left">Raw Results Batch List</span>
      <div class="float-right">
        <input pInputText type="text" (keypress)="handleSearchKey($event, batchlist)" placeholder="Search" [style]="{'margin-right':'15px'}" />
        <a (click)="loadBatchesLazy(null)" class="text-white iconbutton" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i></a>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="width:50px">&nbsp;</th>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}">
        {{col.header}}
        <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
      </th>
      <th style="width:50px">&nbsp;</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr *ngIf="rowData['IsError'] == true" class="table-danger">
      <td>
      </td>
      <td>{{rowData['FileName']}}</td>
      <td>{{rowData['CreatedDate'] | date:'MM/dd/yyyy HH:mm'}}</td>
      <td colspan="9">{{rowData['ErrorDescription']}}</td>
    </tr>

    <tr *ngIf="rowData['IsError'] == false" [style.background-color]="rowData['Completed']===true?'lightgreen':'transparent'">
      <td>
        <button type="button" pButton pRipple class="p-button-text p-button-rounded p-button-plain" [icon]="rowData['showDetail'] ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" (click)="rowData['showDetail'] = !rowData['showDetail'];"></button>
        <!--<i class="pi pi-check" [hidden]="rowData['Completed']!==true"></i>-->
      </td>
      <td *ngFor="let col of columns" [ngSwitch]="col.field">
        <span *ngSwitchDefault>{{rowData[col.field]}}</span>
        <span *ngSwitchCase="'CreatedDate'">
          {{rowData[col.field] | date:'MM/dd/yyyy HH:mm'}}
        </span>
        <span *ngSwitchCase="'SignedOffDate'">
          {{rowData[col.field] | date:'MM/dd/yyyy HH:mm'}}
        </span>
      </td>
      <td>
        <button *hasClaim="'Lab_Archive'" type="button" pButton pRipple class="p-button-text p-button-rounded p-button-plain" icon="pi pi-trash" (click)="deleteBatch(rowData['Id']);"></button>
      </td>
    </tr>
    <tr *ngIf="rowData['showDetail'] == true && rowData['LabTestLIMSCode'] == 'RPP'" [@inOutAnimation]>
      <td colspan="12" style="background-color: whitesmoke; padding: 15px">
        <app-rpp-result-batch (statusChanged)="statusChanged($event)" batchId="{{rowData['Id']}}" searchTerm="{{searchTerm}}"></app-rpp-result-batch>
      </td>
    </tr>
    <tr *ngIf="rowData['showDetail'] == true && useFluLayout(rowData['LabTestLIMSCode'])" [@inOutAnimation]>
      <td colspan="12" style="background-color: whitesmoke; padding: 15px">
        <app-result-batch batchId="{{rowData['Id']}}" searchTerm="{{searchTerm}}"></app-result-batch>
      </td>
    </tr>
    <tr *ngIf="rowData['showDetail'] == true && rowData['LabTestLIMSCode'] == 'NGS-COVID'" [@inOutAnimation]>
      <td colspan="12" style="background-color: whitesmoke; padding: 15px">
        <app-ngscovid-result-batch (statusChanged)="statusChanged($event)" batchId="{{rowData['Id']}}" searchTerm="{{searchTerm}}"></app-ngscovid-result-batch>
      </td>
    </tr>
  </ng-template>
</p-table>
<!--(statusChanged)="statusChanged($event)"-->
<p-toast></p-toast>
<p-confirmDialog icon="pi pi-exclamation-triangle"></p-confirmDialog>
